import { EntityPresenterV2Mode, isStaticMode } from './presenterV2EntityMode';

import type { Maybe } from '@nova/core';
import type { AppointmentDetails } from './appointmentPresenterV2Shared';

export function nestedAppointmentPresenterDataProps(
  mode: EntityPresenterV2Mode,
  data: { appointment?: Maybe<AppointmentDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticAppointmentData: data.appointment ?? null
    };
  }

  return {
    placeholderAppointmentData: data.appointment ?? null
  };
}
